module.exports = __webpack_public_path__ + "img/50.78d7a315.svg";